/** @module csi/slicer/slicerColorDlg */
define([
	"dojo/_base/declare",
	"dojo/query",
	"dijit/form/Button",
	"dijit/registry",
	"csi/_base/underscore",
	"csi/constants",
	"csi/html",
	"csi/locale",
	"csi/types",
	"csi/view/ViewDialog",
	"csi/widget/DateTextBox",
	"csi/widget/InvalidMessage",
	"csi/widget/NumberTextBox",
	"csi/widget/PercentageTextBox",
	"csi/widget/Select"
], function(declare,query,Button,registry,_,constants,html,locale,types,ViewDialog,DateTextBox,
			InvalidMessage,NumberTextBox,PercentageTextBox,Select) {

	/** Options for color select */
	var colors = [
		{value: 1, label:'<div class="csi-slicer-color-hl csi-slicer-color-hl-1"> </div>'},
		{value: 2, label:'<div class="csi-slicer-color-hl csi-slicer-color-hl-2"> </div>'},
		{value: 3, label:'<div class="csi-slicer-color-hl csi-slicer-color-hl-3"> </div>'},
		{value: 4, label:'<div class="csi-slicer-color-hl csi-slicer-color-hl-4"> </div>'}
	];

	return declare(ViewDialog,{
		bSubmitOnEnter: true,
		dialogActions: true,
		destroyOnHide: true,
		'class':'csi-slicer-dlg',
		/**
		 * reference too button "Add Rule". Reference is used to set buton's disabled state
		 * @property {Object} btnAdd
		 */
		btnAdd: null,
		/**
		 * Options  for rule condition select
		 */
		conditions: null,
		/**
		 * @property {InvalidMessage} invalidMessage
		 */
		invalidMessage: null,

		/**
		 * This Configuration Object contains color highlighting rules
		 * @property {Object} hlRules
		 */
		hlRules: {},

		/**
		 * Call to createRules to add dialog content
		 */
		postCreate: function(){
			this.conditions = [{value: constants.SLICER_HL_LESS, label: locale.resource("SlicerRuleLess")},
				{value: constants.SLICER_HL_LESS_EQ, label:locale.resource("SlicerRuleLessOrEqual")},
				{value: constants.SLICER_HL_BETWEEN, label: locale.resource("SlicerRuleBetween")},
				{value: constants.SLICER_HL_GREATER, label: locale.resource("SlicerRuleGreater")},
				{value: constants.SLICER_HL_GREATER_EQ, label: locale.resource("SlicerRuleGreaterOrEqual")},
				{value: constants.SLICER_HL_OTHER, label: locale.resource("SlicerRuleOther") }];
			this.renderRules();

			this.inherited(arguments);
		},

		/**
		 * Focus primary button
		 */
		onRenderDialogActions: function(div){
			registry.byNode(div.firstChild).focusNode.tabIndex = 1;
		},

		/**
		 * Draw rules
		 */
		renderRules: function(){
			var self = this;
			var num = 0;
			var node = html.create('div',{'class':'csi-slicer-dlg-cont'}, this.containerNode, "before");
			this.invalidMessage = new InvalidMessage().placeAt(node);
			html.create('div',{'class':'csi-slicer-color-hl-label', innerText:locale.resource("SlicerRules")}, node);
			var gridWrap = html.create('div',{'class':'csi-slicer-color-hl-grid-container'}, node);
			gridWrap = html.create('div',{'class':'csi-slicer-color-hl-grid'}, gridWrap);
			this.createHeader(gridWrap);
			var rulesWrap = html.create('div',{}, gridWrap);
			_.each(this.hlRules, function(rule){
				num++;
				self.addRule(rule, rulesWrap);
			});
			if (num == 0){
				this.addRule(this.generateUniqueRule(), rulesWrap);
			}
			this.btnAdd = new Button({ // Create New Rule "+" button
				label: "",
				'class':'csi-secondary-btn csi-slicer-btn-new-rule',
				showLabel: false,
				materialIcon: "add",
				onClick: function(){
					self.addRule(self.generateUniqueRule(), rulesWrap);
					self.setBtnAddState();
				}
			}).placeAt(gridWrap);
			this.setBtnAddState();
		},

		createHeader: function(node){
			var div = html.create('div',{'class':'csi-slicer-color-hl-col-header'}, node);
			html.create('span',{'class':'csi-slicer-color-hl-col csi-slicer-color-hl-col1',innerText:locale.resource("SlicerHighlightColor")}, div);
			html.create('span',{'class':'csi-slicer-color-hl-col csi-slicer-color-hl-col2',innerText:locale.resource("SlicerOperator")}, div);
			html.create('span',{'class':'csi-slicer-color-hl-col csi-slicer-color-hl-col3',innerText:locale.resource("SclicerValues")}, div);
			html.create('span',{'class':'csi-slicer-color-hl-col csi-slicer-color-hl-col14'}, div);
		},

		/**
		 * Draw single rule
		 * @param {Object} rule - rule configuration
		 * @param {node} node
		 */
		addRule: function(rule, node){
			var txtVal = null;
			var txtVal2 = null;
			var labelAnd = null;
			var spec = this.metricSpec;
			var bPercent = spec.format && (spec.format.indexOf("%") >= 0);
			var bDate = !bPercent && types.isTimeFormat(spec.format);

			function setControlsVisible(value){
				html.setVisible(txtVal, (value != constants.SLICER_HL_OTHER));
				html.setVisible(labelAnd, (value == constants.SLICER_HL_BETWEEN));
				html.setVisible(txtVal2, (value == constants.SLICER_HL_BETWEEN));
			}
			function getValue(value){
				if ((value == null) || (value === "")){
					return undefined;
				}
				return bPercent ? value : bDate ? types.getTimeDate(value) : spec.ren.formatValue(Number(value), spec.format);
			}

			var self = this;
			var ruleNode = html.create('div',{'class':'csi-slicer-color-rule'}, node);
			var div = html.create('div',{'class':'csi-slicer-color-hl-col csi-slicer-color-hl-col1'}, ruleNode);
			new Select({
				options: colors,
				value: rule.color || 0,
				'class':'csi-slicer-color-hl-colors',
				name: 'color'
			}).placeAt(div);
			div = html.create('div',{'class':'csi-slicer-color-hl-col csi-slicer-color-hl-col2'}, ruleNode);
			new Select({
				options: this.conditions,
				value: rule.condition || 0,
				'class':'csi-slicer-color-hl-condition',
				name: 'compare',
				onChange: function(){
					setControlsVisible(this.value);
				}
			}).placeAt(div);
			div = html.create('div',{'class':'csi-slicer-color-hl-col csi-slicer-color-hl-col3'}, ruleNode);
			var control = (bPercent) ? PercentageTextBox : bDate ? DateTextBox : NumberTextBox;
			txtVal = new control({
				value: getValue(rule.value),
				required: true,
				'class':'csi-slicer-color-hl-value',
				name: 'value',
				constraints: {pattern:spec.format}
			}).placeAt(div);
			labelAnd = html.create('label',{'for':'andValue2', innerText:' - '}, div);
			txtVal2 = new control({
				value: getValue(rule.value2),
				required: true,
				name: 'andValue2',
				'class':'csi-slicer-color-hl-value2',
				name: 'value2',
				constraints: {pattern:spec.format}
			}).placeAt(div);

			setControlsVisible(rule.condition);

			// Create close button
			div = html.create('div',{'class':'csi-slicer-color-hl-col csi-slicer-color-hl-col4'}, ruleNode);
			new Button({
				label: "",
				'class':'csi-slicer-hl-rule-cross',
				showLabel: false,
				materialIcon: "close",
				onClick: function(){
					html.destroyElement(ruleNode);
					self.setBtnAddState();
				}
			}).placeAt(div);
		},

		/**
		 * This function checks which conditions where already taken and generate new rule with first available (not used) conditions and colors
		 * @return {Object}
		 */
		generateUniqueRule: function(){
			var res = {};
			var usedColors = [];
			var usedConditions = [];
			var nodes = query('.csi-slicer-color-rule', this.domNode);
			_.each(nodes, function(node){
				var _node = query('.csi-slicer-color-hl-colors', node)[0];
				usedColors.push(registry.byNode(_node).value);
				_node = query('.csi-slicer-color-hl-condition', node)[0];
				var cond = this._removeOrEqual(registry.byNode(_node).value);
				if (usedConditions.indexOf(cond) < 0){
					usedConditions.push(cond);
				}
			}, this);
			_.some(colors, function(color){
				if (usedColors.indexOf(color.value) < 0 ){
					res.color = color.value;
					return true;
				}
			});
			_.some(this.conditions, function(condition){
				if (usedConditions.indexOf(this._removeOrEqual(condition.value)) < 0 ){
					res.condition = condition.value;
					return true;
				}
			}, this);
			res.value = '';
			res.value2 = '';
			return res;
		},

		/**
		 * Get new values and validate data
		 * @return {boolean} - true if valid
		 */
		validate: function(){
			this.updateValue();
			var res = this._validate();
			return res;
		},

		/**
		 * Sometimes we need to ignore "or equal" and treat "lte" just like "lt", or "gte" like "gt".
		 * This function remove "or equal" part of the condition and return the rest.
		 * @param {strong} condition
		 * @return {string}
		 */
		_removeOrEqual: function(condition){
			if (condition[condition.length - 1] == 'e'){
				return condition.substring(0, condition.length - 1);
			} else {
				return condition;
			}
		},

		/**
		 * Validate our data
		 * @return {boolean} - true if valid
		 */
		_validate: function(){
			var val = this.get('hlRules');
			var usedConditions = [];
			this.invalidMessage.set('value', '');
			return !_.some(val, function(v){
				if (v.condition != constants.SLICER_HL_OTHER){
					if (isNaN(v.value) || ((v.condition == constants.SLICER_HL_BETWEEN) && isNaN(v.value2)) ){
						this.invalidMessage.set('value', locale.resource("RequiredValue"));
						return true;
					}
				}
				var cond = this._removeOrEqual(v.condition);
				if(usedConditions.indexOf(cond) >= 0){
					this.invalidMessage.set('value', locale.resource("SlicerDuplicateConditions"));
					return true;
				}
				usedConditions.push(cond);
				return false;
			}, this);
		},

		/**
		 * Retrieve data from controls
		 * @return {Object[]}
		 */
		updateValue: function(){
			var res = [];
			var nodes = query('.csi-slicer-color-rule', this.domNode);
			_.each(nodes, function(node){
				var val = {};
				var _node = query('.csi-slicer-color-hl-colors', node)[0];
				val.color = registry.byNode(_node).value;
				_node = query('.csi-slicer-color-hl-condition', node)[0];
				val.condition = registry.byNode(_node).value;
				_node = query('.csi-slicer-color-hl-value', node)[0];
				var valEdit = registry.byNode(_node);
				val.value = valEdit.get("value");
				if (!valEdit.isValid()){
					valEdit.focus();
					valEdit.displayMessage();
				}
				_node = query('.csi-slicer-color-hl-value2', node)[0];
				if (_node && html.isVisible(_node)) {
					var valEdit2 = registry.byNode(_node);
					val.value2 = valEdit2.get("value");
					if (!valEdit2.isValid()){
						valEdit2.focus();
						valEdit2.displayMessage();
					}
				}
				if (types.isTimeFormat(this.metricSpec.format)){
					val.value = types.getDateTime(val.value);
					if (val.value2){
						val.value2 = types.getDateTime(val.value2);
					}
				}
				res.push(val);
			}, this);
			this.set('hlRules', res);
		},

		/**
		 * Set disabled state of button "Add Rule". We allow maximum of 4 rules for now.
		 */
		setBtnAddState: function() {
			var nodes = query('.csi-slicer-color-rule', this.domNode);
			this.btnAdd.set('disabled', nodes.length >= 4);
		},

		/**
		 * Overwrite default function to make "onSave" always works. We use our own validation methods.
		 */
		_hasValueChanged: function(){
			return true;
		}
	});
});
